if (!customElements.get('main-review')) {
  customElements.define(
    'main-review',
    class Review extends HTMLElement {
      constructor() {
        super();

        window.addEventListener('sliderIsCreated', function (e) {
          if (e.detail.section == 'main-review') {
            if (
              document.querySelector('.review_content') != undefined &&
              document.querySelectorAll('.review_content').length > 0
            ) {
              setAllToMaxHeight('.review_content');
            } 
          }
        });
      }

    },
  );
  
  
  
}
